<div
  *appHasAccess="['VIRTUAL_POS_VIEW']"
  #contentBlock
  class="user-page">
  <div class="page-head">
    <div class="page-head__left">
      <ng-container *appHasAccess="['VIRTUAL_POS_EDIT']">
        <button
          *ngIf="selectedRow.length === 1"
          (click)="edit(selectedRow[0])"
          class="btn btn-light-filter icon">
          <svg
            class="icon-button"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2 11.5V14H4.5L11.8733 6.62662L9.37333 4.12662L2 11.5ZM13.8067 4.69329C14.0667 4.43329 14.0667 4.01329 13.8067 3.75329L12.2467 2.19329C11.9867 1.93329 11.5667 1.93329 11.3067 2.19329L10.0867 3.41329L12.5867 5.91329L13.8067 4.69329Z" />
          </svg>
          {{ "VIRTUAL_POS_PAGE.EDIT_BUTTON" | translate }}
        </button>
      </ng-container>

      <ng-container *appHasAccess="['VIRTUAL_POS_BLOCK']">
        <button
          *ngIf="selectedRow.length > 0 && groupStatus === 'unlocked'"
          (click)="toggleGroupBlock()"
          class="btn btn-light-filter icon">
          <svg
            class="icon-button"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.93333 3.99996C5.93333 2.85996 6.86 1.93329 8 1.93329C9.14 1.93329 10.0667 2.85996 10.0667 3.99996V5.33329H6.96L8.29333 6.66663H12V10.3733L13.3333 11.7066V6.66663C13.3333 5.93329 12.7333 5.33329 12 5.33329H11.3333V3.99996C11.3333 2.15996 9.84 0.666626 8 0.666626C6.45333 0.666626 5.16 1.72663 4.78667 3.15996L5.93333 4.30663V3.99996ZM2.94 3.20663L2 4.14663L3.36 5.50663C2.94667 5.73329 2.66667 6.16663 2.66667 6.66663V13.3333C2.66667 14.0666 3.26667 14.6666 4 14.6666H12.52L13.1867 15.3333L14.1267 14.3933L2.94 3.20663ZM4 13.3333V6.66663H4.52L11.1867 13.3333H4Z" />
          </svg>
          {{ "VIRTUAL_POS_PAGE.BLOCKED_BUTTON" | translate }}
        </button>
      </ng-container>

      <ng-container *appHasAccess="['VIRTUAL_POS_BLOCK']">
        <button
          *ngIf="selectedRow.length > 0 && groupStatus === 'blocked'"
          (click)="toggleGroupBlock()"
          class="btn btn-light-filter icon">
          <svg
            class="icon-button-stroke"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6 6V4.01612C6 3.36551 6.25845 2.74155 6.71851 2.28149C6.90495 2.09505 7.12023 1.93989 7.35606 1.82197L7.51295 1.74352C7.83325 1.58338 8.18643 1.5 8.54454 1.5C9.15631 1.5 9.74303 1.74303 10.1756 2.17561L10.5 2.5M4.07989 6.50195H11.6391C12.2355 6.50195 12.719 7.17949 12.719 8.01527V13.3119C12.719 14.1477 12.2355 14.8252 11.6391 14.8252H4.07989C3.48348 14.8252 3 14.1477 3 13.3119V8.01527C3 7.17949 3.48348 6.50195 4.07989 6.50195Z"
              stroke-width="1.3"
              stroke-linejoin="round" />
          </svg>
          {{ "VIRTUAL_POS_PAGE.UNLOCKED_BUTTON" | translate }}
        </button>
      </ng-container>

      <ng-container *appHasAccess="['VIRTUAL_POS_DELETE']">
        <button
          *ngIf="selectedRow.length > 0"
          (click)="deleteGroup()"
          class="btn btn-light-filter icon">
          <svg
            class="icon-button"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.64734 1.3501H9.02246C9.31526 1.35009 9.56709 1.35008 9.77535 1.36429C9.99439 1.37924 10.2123 1.41205 10.4272 1.50107C10.9134 1.70245 11.2993 2.08882 11.5005 2.5746C11.5895 2.78945 11.6224 3.00727 11.6373 3.22632C11.64 3.266 11.6422 3.30727 11.644 3.3501H13.6682C14.0272 3.3501 14.3182 3.64111 14.3182 4.0001C14.3182 4.35908 14.0272 4.6501 13.6682 4.6501H12.9849V11.894C12.9849 12.2452 12.9849 12.5472 12.9646 12.7959C12.9431 13.0581 12.8959 13.3176 12.7689 13.5669C12.5786 13.9402 12.2746 14.244 11.9016 14.4341C11.6523 14.5611 11.3929 14.6083 11.1307 14.6298C10.882 14.6501 10.58 14.6501 10.2288 14.6501H6.44102C6.08984 14.6501 5.78767 14.6501 5.5389 14.6298C5.27665 14.6084 5.01705 14.5611 4.76767 14.4341C4.39391 14.2436 4.09093 13.9395 3.90107 13.5669C3.77395 13.3174 3.72668 13.0578 3.70522 12.7953C3.68487 12.5463 3.68488 12.2438 3.6849 11.892L3.6849 4.6501H3.00156C2.64258 4.6501 2.35156 4.35908 2.35156 4.0001C2.35156 3.64111 2.64258 3.3501 3.00156 3.3501H5.02575C5.02753 3.30729 5.02972 3.26604 5.03242 3.22638C5.04737 3.00735 5.08019 2.78949 5.1692 2.5746C5.37038 2.08891 5.75614 1.70249 6.2424 1.50107C6.45734 1.41204 6.67532 1.37923 6.89437 1.36429C7.10267 1.35008 7.35453 1.35009 7.64734 1.3501ZM6.32722 3.3501H10.3425C10.3419 3.33811 10.3411 3.32641 10.3404 3.31495C10.3299 3.16219 10.312 3.10226 10.2995 3.07208C10.23 2.90445 10.097 2.77139 9.92973 2.70211C9.89962 2.68964 9.8397 2.67171 9.68686 2.66128C9.52817 2.65045 9.32108 2.6501 9.00156 2.6501H7.66823C7.34871 2.6501 7.14157 2.65045 6.98284 2.66128C6.82992 2.67171 6.76998 2.68965 6.73989 2.70211C6.57274 2.77135 6.43972 2.90436 6.37024 3.07208C6.35776 3.10222 6.33983 3.16211 6.32941 3.31489C6.32862 3.32636 6.3279 3.33809 6.32722 3.3501ZM4.9849 4.6501V11.8668C4.9849 12.2509 4.9854 12.4998 5.0009 12.6894C5.01578 12.8714 5.04116 12.941 5.05937 12.9767C5.12518 13.1059 5.22984 13.2105 5.35785 13.2758C5.39341 13.2939 5.46287 13.3192 5.64478 13.3341C5.83424 13.3496 6.08281 13.3501 6.46617 13.3501H10.2036C10.587 13.3501 10.8354 13.3496 11.0247 13.3341C11.2064 13.3193 11.2758 13.2939 11.3114 13.2758C11.4401 13.2102 11.5451 13.1052 11.6106 12.9767C11.6287 12.9411 11.6541 12.8717 11.6689 12.69C11.6844 12.5006 11.6849 12.2522 11.6849 11.8688V4.6501H4.9849ZM7.00156 6.01677C7.36055 6.01677 7.65156 6.30778 7.65156 6.66677V11.3334C7.65156 11.6924 7.36055 11.9834 7.00156 11.9834C6.64258 11.9834 6.35156 11.6924 6.35156 11.3334V6.66677C6.35156 6.30778 6.64258 6.01677 7.00156 6.01677ZM9.66823 6.01677C10.0272 6.01677 10.3182 6.30778 10.3182 6.66677V11.3334C10.3182 11.6924 10.0272 11.9834 9.66823 11.9834C9.30924 11.9834 9.01823 11.6924 9.01823 11.3334V6.66677C9.01823 6.30778 9.30924 6.01677 9.66823 6.01677Z" />
          </svg>
          {{ "VIRTUAL_POS_PAGE.DELETE_BUTTON" | translate }}
        </button>
      </ng-container>
    </div>
    <div class="page-head__right">
      <app-filter-button
        [isOpenFilter]="isOpenFilter"
        [isEnableUpload]="false"
        (toggleFilterEvent)="toggleFilter($event)">
      </app-filter-button>
    </div>
  </div>

  <div class="payment-page__filer">
    <app-filter-block
      [additional]="filterAdditional"
      [(isOpenFilter)]="isOpenFilter">
      <app-virtual-cash-page-filter
        [filterP2p]="filterP2p"
        [filterCurrency]="filterCurrency"
        [filterStatuses]="filterStatuses">
      </app-virtual-cash-page-filter>
    </app-filter-block>
  </div>

  <div class="user-page__body">
    <div
      #tableBlock
      (scroll)="onScroll($event)"
      class="table">
      <div class="table-head">
        <div class="table__row">
          <div class="column table__row-head">
            <app-checkbox-all-table
              [rowCount]="virtualPosList.length"
              [selectedRowCount]="selectedRow.length">
            </app-checkbox-all-table>
          </div>
          <div class="column table__row-head"></div>

          <div
            (click)="sortColumn('IS_BLOCKED')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'IS_BLOCKED'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "VIRTUAL_POS_PAGE.STATUS" | translate }}
            </span>
          </div>

          <div
            (click)="sortColumn('VIRTUAL_POS_ID')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'VIRTUAL_POS_ID'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "VIRTUAL_POS_PAGE.VIRTUAL_ID" | translate }}
            </span>
          </div>

          <div
            (click)="sortColumn('VIRTUAL_POS_NAME')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'VIRTUAL_POS_NAME'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "VIRTUAL_POS_PAGE.CASH_TERMINAL" | translate }}
            </span>
          </div>

          <div
            (click)="sortColumn('CURRENCY')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'CURRENCY'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "VIRTUAL_POS_PAGE.CURRENCY" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('COMMISSION')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'COMMISSION'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "VIRTUAL_POS_PAGE.COMMISSION_PERCENT" | translate }}
            </span>
          </div>
        </div>
      </div>
      <div
        #tableBody
        class="table-body">
        <div
          *ngFor="let item of virtualPosList; index as i"
          class="table__row">
          <div class="column table__row-data">
            <app-checkbox-table
              (changeItem)="checkChange($event)"
              [item]="{ id: item.id }">
            </app-checkbox-table>
          </div>
          <div class="column table__row-data">
            <app-context-menu [isDisabled]="selectedRow.length !== 0">
              <app-virtual-pos-context-menu
                (commissionEvent)="commission($event)"
                (editEvent)="edit($event)"
                (deleteEvent)="delete($event)"
                (blockedEvent)="toggleBlock($event)"
                (unlockedEvent)="toggleBlock($event)"
                [item]="item">
              </app-virtual-pos-context-menu>
            </app-context-menu>
          </div>
          <div  class="column table__row-data">
            <app-switch-table
              (click)="toggleBlock(virtualPosList[i])"
              [isDisabled]="true"
              [item]="{ id: i.toString(), state: !item.is_blocked }">
            </app-switch-table>
          </div>
          <div
            (dblclick)="openTerminalList(item.id)"
            class="column table__row-data">
            <span class="mobile"> {{ "VIRTUAL_POS_PAGE.VIRTUAL_ID" | translate }}: </span>
            {{ item.id }}
          </div>
          <div
            (dblclick)="openTerminalList(item.id)"
            class="column table__row-data">
            {{ item.virtual_pos_name }}
          </div>
          <div
            (dblclick)="openTerminalList(item.id)"
            class="column table__row-data">
            <span class="mobile"> {{ "VIRTUAL_POS_PAGE.CURRENCY" | translate }}: </span>
            {{ item.currency }}
          </div>
          <div
            (dblclick)="openTerminalList(item.id)"
            class="column table__row-data">
            <span class="mobile"> {{ "VIRTUAL_POS_PAGE.COMMISSION_PERCENT" | translate }}: </span>
            {{ item.commission }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-modal
  [isFull]="true"
  [(isOpenModal)]="isOpenModalEditVirtualCash">
  <app-edit-virtual-cash-dialog
    *ngIf="isOpenModalEditVirtualCash"
    [selectedVirtualPosId]="selectedVirtualPosId"
    [currenciesList]="currenciesList"
    (updateCashEvent)="editedVirtualPos()">
  </app-edit-virtual-cash-dialog>
</app-modal>

<app-modal
  [isFull]="true"
  [typeBg]="'main-bg'"
  [(isOpenModal)]="isOpenModalCommissionVirtualCash">
  <app-commission-virtual-cash-dialog [percentData]="percentData"> </app-commission-virtual-cash-dialog>
</app-modal>

<app-modal [(isOpenModal)]="isOpenModalDeleteVirtualCash">
  <app-delete-virtual-cash-dialog
    (deleteEvent)="deleteVirtualCash($event)"
    [deleteId]="deleteId">
  </app-delete-virtual-cash-dialog>
</app-modal>

<app-modal [(isOpenModal)]="isOpenModalToggleVirtualCash">
  <app-toggle-block-virtrual-cash-dialog
    (unlockEvent)="unlocked($event)"
    (blockEvent)="blocked($event)"
    [selectedVirtualPos]="selectedVirtualPos">
  </app-toggle-block-virtrual-cash-dialog>
</app-modal>

<app-modal [(isOpenModal)]="isOpenModalGroupToggleVirtualCash">
  <app-toggle-group-block-virtrual-cash-dialog
    (unlockEvent)="groupUnlocked()"
    (blockEvent)="groupBlocked()"
    [virtualPosCount]="selectedRow.length"
    [groupStatus]="groupStatus">
  </app-toggle-group-block-virtrual-cash-dialog>
</app-modal>

<app-modal [(isOpenModal)]="isOpenModalDeleteGroupVirtualCash">
  <app-delete-group-virtual-cash-dialog
    (deleteEvent)="deleteGroupVirtualCash()"
    [deleteGroup]="selectedRow">
  </app-delete-group-virtual-cash-dialog>
</app-modal>
